import { useState, useContext, useEffect, useRef } from "react";
import Header from "../../Components/Header";
import WeightQuestion from "../../Components/Step3/WeightQuestion";
import Documents from "../../Components/Step3/Documents";
import Message from "../../Components/Step3/Message";
import ProgressBar from "../../Components/ProgressBar";
import { useNavigate } from "react-router-dom";
import "./step3.css";
import PortalContext from "../PortalContext";
import SkuRow from "./SkuRow";
import SkuRowMobile from "./SkuRowMobile";
import { useGetTranslation } from "../../Components/Translate";

export default function Step3() {
  const { portal } = useContext(PortalContext);
  const getTranslation = useGetTranslation();

  const messageRefDesktop = useRef();
  const messageRefMobile = useRef();

  const [weightQuestion, setWeightQuestion] = useState(
    portal?.step3?.weightQuestion ?? undefined
  );

  const navigate = useNavigate();

  // Build initial normalized items array
  const buildInitialItems = () => {
    if (portal?.step3?.items?.length) return portal.step3.items;

    return (portal?.SKUs || []).map((sku, index) => ({
      index,
      sku: sku.SKU_code,
      name: sku.SKU_name,
      image: sku.SKU_image_URL,
      selected: false,
      quantity: 0,
      reason: "",
      action: "",
    }));
  };

  const [inputs, setInputs] = useState(() => ({
    items: buildInitialItems(),
    message: portal?.step3?.message || "",
    weightQuestion: portal?.step3?.weightQuestion ?? undefined,
  }));

  // Patch a single item by index
  const setItem = (index, patch) => {
    setInputs((prev) => {
      const items = [...prev.items];
      items[index] = { ...items[index], ...patch };
      return { ...prev, items };
    });
  };

  useEffect(() => {
    if (
      !portal?.SKUs ||
      !portal?.data ||
      !portal?.data?.settings ||
      !portal?.step2?.country
    ) {
      // navigate(`/`, {
      //   replace: true,
      // });
      navigate(`/`);
    }
  }, [portal, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation against normalized structure
    const selectedItems = inputs.items.filter((i) => i.selected);
    const hasChecked = selectedItems.length > 0;
    const hasReturnTrueAndQuantityZero = selectedItems.some(
      (i) => (Number(i.quantity) || 0) <= 0
    );

    if (hasReturnTrueAndQuantityZero || !hasChecked) {
      alert(
        "Please select at least one item to return, and ensure that the quantity is greater than 0."
      );
      return;
    }

    // Prefer first non-empty message (desktop hidden field can be empty string)
    const pickNonEmpty = (v) =>
      typeof v === "string" && v.trim() === "" ? undefined : v;

    const desktopVal = pickNonEmpty(messageRefDesktop.current?.value);
    const mobileVal = pickNonEmpty(messageRefMobile.current?.value);
    const messageVal = desktopVal ?? mobileVal ?? inputs.message;

    // Persist to portal in normalized shape
    portal.step3 = {
      ...inputs,
      message: messageVal,
      weightQuestion,
      // documents: portal.documents || [],
    };

    // navigate(`/step-4`, {
    //   replace: true,
    // });

    navigate(`/step-4`);
  };

  return (
    <>
      <Header />

      <section class="page3-slider py-lg-3">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-lg-12 col-12 pb-5">
              <ProgressBar step={3} />

              <h2>
                {getTranslation(
                  "STEP3_TITLE",
                  "What would you like to return?"
                )}
              </h2>

              <div class="align-items-center mt-3 d-none d-sm-block">
                <div class="row mt-4">
                  <div class="col-sm-1 d-flex justify-content-center">
                    <div class="header-title">
                      {getTranslation("STEP3_HEADER_SELECT", "Select")}
                    </div>
                  </div>
                  <div class="col-sm-2 d-flex justify-content-center">
                    <div class="header-title">
                      {getTranslation("STEP3_HEADER_PRODUCT", "Product name")}
                    </div>
                  </div>
                  <div class="col-sm-2 d-flex justify-content-center">
                    <div class="header-title">
                      {getTranslation("STEP3_HEADER_IMAGE", "Image")}
                    </div>
                  </div>
                  <div class="col-sm-2 d-flex justify-content-center">
                    <div class="header-title">
                      {getTranslation("STEP3_HEADER_QUANTITY", "Quantity")}
                    </div>
                  </div>
                  <div class="col-sm-3 d-flex justify-content-center dropdown-border">
                    <div class="header-title">
                      {getTranslation("STEP3_HEADER_REASON", "Reason")}
                    </div>
                  </div>
                  <div class="col-sm-2 d-flex justify-content-center">
                    <div class="header-title">
                      {getTranslation("STEP3_HEADER_ACTION", "Action")}
                    </div>
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  {portal?.SKUs?.map((item, index) => (
                    <SkuRow
                      key={index}
                      index={index}
                      item={item}
                      itemState={inputs.items[index]}
                      setItem={setItem}
                      settings={portal?.data?.settings}
                    />
                  ))}

                  <div
                    className="cust-msg-para"
                    dangerouslySetInnerHTML={{
                      __html: portal?.data?.settings?.custMsgPara || "",
                    }}
                  />

                  <Message
                    key="desktop"
                    messageRef={messageRefDesktop}
                    defaultMessage={inputs.message}
                  />

                  {portal?.data?.settings?.documents && <Documents />}

                  {portal?.data?.settings?.weightQuestions?.[
                    portal?.step2?.country
                  ] && (
                    <>
                      <WeightQuestion
                        weightQuestion={weightQuestion}
                        setWeightQuestion={setWeightQuestion}
                      />
                    </>
                  )}

                  <div class="row mt-4">
                    <div class="col-sm-2">
                      <button
                        type="submit"
                        style={{
                          backgroundColor: `${portal.data.settings.colours.primary}`,
                        }}
                      >
                        {getTranslation("CONTINUE_BUTTON", "Continue")}
                      </button>
                    </div>

                    <div class="col-sm-3 photo-button"></div>

                    <div class="col-sm-3  "></div>
                    <div class="col-sm-4 d-flex justify-content-end ">
                      <img
                        src={require("../../Assets/Images/powered-by.png")}
                        class="powered-logo"
                      ></img>
                    </div>
                  </div>
                </form>
              </div>

              {/* Mobile */}
              <div class="align-items-center mt-3 d-block d-sm-none">
                <form onSubmit={handleSubmit}>
                  {portal?.SKUs?.map((item, index) => (
                    <SkuRowMobile
                      key={index}
                      index={index}
                      item={item}
                      itemState={inputs.items[index]}
                      setItem={setItem}
                    />
                  ))}

                  <Message
                    key="mobile"
                    messageRef={messageRefMobile}
                    defaultMessage={inputs.message}
                  />

                  {portal?.data?.settings?.documents && <Documents />}

                  {portal?.data?.settings?.weightQuestions?.[
                    portal?.step2?.country
                  ] && (
                    <>
                      <WeightQuestion
                        weightQuestion={weightQuestion}
                        setWeightQuestion={setWeightQuestion}
                      />
                    </>
                  )}

                  <div class="row mt-4">
                    <div class="col-sm-2">
                      <button
                        type="submit"
                        style={{
                          backgroundColor: `${portal.data.settings.colours.primary}`,
                        }}
                      >
                        {getTranslation("CONTINUE_BUTTON", "Continue")}
                      </button>
                    </div>

                    <div class="col-sm-3 photo-button"></div>

                    <div class="col-sm-3  "></div>
                    <div class="col-sm-4 d-flex justify-content-end ">
                      <img
                        src={require("../../Assets/Images/powered-by.png")}
                        class="powered-logo"
                      ></img>
                    </div>
                  </div>
                </form>
              </div>
              {/* End mobile */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
